import { $api } from "../generated/client";

type ProductsAnalyticsParams = {
	fromTimestamp: number;
	toTimestamp: number;
	productId?: string;
	variantId?: string;
	resolution?: string;
	reason?: string;
};

export default function useProductsSummaryAnalytics(
	shopId: string,
	params: ProductsAnalyticsParams,
) {
	return $api.useQuery("get", "/shops/{shopId}/analytics/products", {
		params: {
			path: { shopId },
			query: params,
		},
		enabled: !!params.toTimestamp,
	});
}
